export enum MarketsType {
  FAVORITES,
  RECENT,
  ALL,
  CRYPTO,
  RWA,
  NEW_LISTING,
  COMMUNITY,
  PRE_TGE,
}
